import type { CalcPosition } from '../types/calculation.types'

/**
 * AP-37 Nachtrag 1 (N1-23) — **Filter nach Art** für Positionsübersicht und
 * Positionsliste, an einer Stelle definiert, damit beide dasselbe zeigen.
 *
 * - Leistungsposition: alles außer der reinen Textposition (Vorbemerkungen).
 * - Lückentext: die Position hat eine Bieterlücke — ausgefüllt oder nicht.
 * - Ohne Preis: eine Leistungsposition mit EP 0 (Textpositionen haben nie einen Preis).
 */
export type PositionsArtFilter = '' | 'LEISTUNG' | 'LUECKE' | 'OHNE_PREIS'

export const POSITIONS_ART_FILTER: { wert: PositionsArtFilter; text: string }[] = [
  { wert: '', text: 'alle Positionen' },
  { wert: 'LEISTUNG', text: 'nur Leistungspositionen' },
  { wert: 'LUECKE', text: 'nur mit Lückentext' },
  { wert: 'OHNE_PREIS', text: 'nur ohne Preis' },
]

export function passtArt(p: CalcPosition, filter: PositionsArtFilter): boolean {
  switch (filter) {
    case 'LEISTUNG':
      return p.kind !== 'TEXT'
    case 'LUECKE':
      return Boolean(p.gapQuestion)
    case 'OHNE_PREIS':
      return p.kind !== 'TEXT' && !(p.unitPrice > 0)
    default:
      return true
  }
}
